import { createHead } from '@vueuse/head';

import { defineAppPlugin } from '@/main';

export default defineAppPlugin(context => {
  const head = createHead();

  context.app.use(head);
});
